export const environment = {
  production: false,
  // apiUrl: 'http://localhost:5100/api',
  // appImageUrl:'http://localhost:5100/MediaUploads/FileUpload/',
  apiUrl: 'https://apiv2.maark.my/api',
  appImageUrl: 'https://apiv2.maark.my/MediaUploads/FileUpload/',
  appName: 'maarkV2',
  version: '20260203.01.21577fb',
  googleMapsKey: 'AIzaSyAzzv0uzTJsDnsxVoBKYg1xNn8bCBrMErM',
};
